module.exports = __webpack_public_path__ + "static/media/icon_tp.4d99f3d3.svg";